// extracted by mini-css-extract-plugin
export default {"searchBar":"DesktopSearchBar_searchBar__V2UTV"};